import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { pluck, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { CacheService } from './cache.service';

interface BffProject {
  project: BffProjectInfo
}

interface BffProjectInfo {
  name: string;
  version: string;
}

@Injectable({
  providedIn: 'root'
})
export class BffVersionService {
  constructor(private http: HttpClient, private cacheService: CacheService) {}

  getBffVersion(): Observable<string> {
    const url: string = environment.endpoint.replace('api/v1', 'management/info');
    const request: Observable<string> = this.http.get<BffProject>(url).pipe(
      map(val => val.project),
      map((projectInfo: BffProjectInfo) => projectInfo.version)
    );

    return this.cacheService.cache(url, request);
  }
}
